/* eslint-disable no-use-before-define */
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import React, { FC } from 'react';
import { useStyles } from './style';

export interface ITablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onChangePage: (event: any, newPage: number) => void;
}

const VISIBLE_PAGES = 5;

const TablePaginationActions: FC<ITablePaginationActionsProps> = props => {
  const classes = useStyles();
  const { count, page, rowsPerPage, onChangePage } = props;
  const pageCount = Math.max(1, Math.ceil(count / rowsPerPage));

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onChangePage(event, page + 1);
  };

  const handlePageButtonClick = (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => {
    onChangePage(event, newPage);
  };

  const getVisiblePages = () => {
    const current = page || 0;
    if (pageCount <= VISIBLE_PAGES) {
      return Array.from({ length: pageCount }, (_, index) => index);
    }

    let begin = Math.max(0, current - Math.floor(VISIBLE_PAGES / 2));
    let end = begin + VISIBLE_PAGES;
    if (end > pageCount) {
      end = pageCount;
      begin = pageCount - VISIBLE_PAGES;
    }

    return Array.from({ length: end - begin }, (_, index) => begin + index);
  };

  if (rowsPerPage >= count) {
    return null;
  }

  return (
    <div className={classes.paginationFooter}>
      <button
        type="button"
        className={classes.navBtn}
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page">
        <ChevronLeft />
      </button>

      {getVisiblePages().map(pageIndex => (
        <button
          key={pageIndex}
          type="button"
          className={`${classes.pageBtn} ${page === pageIndex ? classes.pageBtnActive : ''}`}
          onClick={event => handlePageButtonClick(event, pageIndex)}
          aria-current={page === pageIndex ? 'page' : undefined}>
          {pageIndex + 1}
        </button>
      ))}

      <button
        type="button"
        className={classes.navBtn}
        onClick={handleNextButtonClick}
        disabled={page >= pageCount - 1}
        aria-label="next page">
        <ChevronRight />
      </button>
    </div>
  );
};

export default TablePaginationActions;
